import React, { useEffect } from 'react';

import { useTheme } from '@/services/theme';
import {
  ModalBody,
  ModalButton,
  ModalContainer,
  ModalContent,
  ModalOverlay,
  ModalTitle,
} from '@/pages/LandingPage/sections/ContactUs/components/ui/Modal';

type DoneWindowProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const DoneWindow: React.FC<DoneWindowProps> = ({ isOpen, onClose }) => {
  const { theme } = useTheme();

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
  }, [isOpen]);

  return (
    isOpen && (
      <ModalContainer theme={theme}>
        <ModalOverlay></ModalOverlay>
        <ModalContent>
          <ModalTitle>Message sent</ModalTitle>
          <ModalBody>
            We will review your proposal and get back to you as soon as possible.
          </ModalBody>
          <ModalButton onClick={onClose}>Okay</ModalButton>
        </ModalContent>
      </ModalContainer>
    )
  );
};
